__turbopack_context__.v({
  "root": "CookieAcceptation-module-scss-module__ZS8VWG__root",
  "text": "CookieAcceptation-module-scss-module__ZS8VWG__text",
});
